import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.3rem;
      margin: 0;
    }
  }

  .editPen {
    height: 2rem;
    fill: ${({ theme }) => theme.colors.secondary};
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h2 {
    margin: 1rem 0 0 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.text};
    font-weight: lighter;
  }

  p {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.1rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
    margin-top: 0.4rem;
  }

  .MuiInput - input {
    font - size: 1.2rem;
  }

  .containerAddress {
    display: flex;
    gap: 1rem;
    width: 100 %;

    .postalCodeInput {
      width: 100 %;
    }

    .street {
      width: 100 %;
    }

    .number {
      width: 100 %;
    }
  }

  .containerComplement .container {
    width: 100%;
  }

  .buttonModal {
    display: flex;
    justify-content: flex-end;
    margin: 2rem 0 0 0;
  }

  @media(max-width: 660px){
    .buttonModal {
      margin: 1rem 0 0 0;
    }
  }

  @media(max-width: 560px){
    .containerAddress {
      flex-direction: column;
    }
  }

  @media(max-width: 350px){
    .buttonModal button{
      width: 100% !important;
    }
  }
`;
